import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { PreviaInspectorService } from '../../solicitudes/previaInspector/previaInspector.service';
import { SolicitudService } from '../datosbasicos/datosbasicos.service';
import { TPreviaInspectorSolicitudViewModel, SolicitudPreviaInspectorViewModel } from './previaInspector.types';
import { EnumCodigosTwTcAcciones, EnumIdsTcEstadoSolicitud, EnumIdsTwTcTipoClonacion } from '../types/enum';

@Component({
    selector: 'app-previainspector-edit',
    templateUrl: './previaInspector-edit.component.html',
})
export class PreviaInspectorEditComponent extends ComponentBase implements OnInit {
    esSolicitante = true;
    nombreInspector = '';
    solicitudPreviaInspector: SolicitudPreviaInspectorViewModel;
    previa: TPreviaInspectorSolicitudViewModel;
    idSolicitud = 0;
    tituloTipoSolicitud: string;

    habilitarGuardar = true;
    esNuevaPrevia = false;
    visibilitySpinner = false;
    esClonada = false;

    constructor(
        public datepipe: DatePipe,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private solicitudService: SolicitudService,
        private navMenuService: NavMenuService,
        private previaInspectorService: PreviaInspectorService,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.solicitudPreviaInspector = new SolicitudPreviaInspectorViewModel();
    }

    ngOnInit() {
        this.idSolicitud = +this.activatedRoute.snapshot.params['id'];

        this.guardRefreshPage(this.idSolicitud);

        this.createForm();

        if (this.idSolicitud) {
            this.loading = true;

            this.previaInspectorService.getSolicitudPreviaInspector(this.idSolicitud).subscribe(result => {
                this.solicitudPreviaInspector = result;
                this.tituloTipoSolicitud = this.solicitudPreviaInspector.IdTipoSolicitudDescripcion;
                this.esClonada =
                    this.solicitudPreviaInspector.TwSolicitudJerarquia != null &&
                    this.solicitudPreviaInspector.TwSolicitudJerarquia.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                        ? true
                        : false;
                //SI ES RE-IMPORTACION
                if (this.solicitudPreviaInspector.EsReImportacion) {
                    this.tituloTipoSolicitud += ' - Re-Importación';
                }
                //SI ES PREVIA
                if (this.solicitudPreviaInspector.EsPrevia) {
                    if (
                        this.solicitudPreviaInspector.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA &&
                        this.solicitudPreviaInspector.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_PENDIENTE
                    ) {
                        this.tituloTipoSolicitud += ' - Previa';
                    }
                }

                this.esNuevaPrevia = this.solicitudPreviaInspector.TPreviaInspector == null ? true : false;

                if (this.esNuevaPrevia) {
                    this.form.patchValue({
                        IdInspector: this.loggedInUser!.Id,
                    });

                    //this.form.controls['Observaciones'].enable();
                    //this.form.controls["Aceptada"].enable();
                } else {
                    this.updateForm();
                }

                this.habilitarGuardar = this.loggedInUser!.getAction(
                    EnumCodigosTwTcAcciones.MENU_PREVIA,
                    this.solicitudPreviaInspector.IdEstadoSolicitud,
                    this.solicitudPreviaInspector.IdTipoSolicitud,
                ).Editable;

                if (this.habilitarGuardar) {
                    this.form.controls['Aceptada'].enable();
                    this.form.controls['Observaciones'].enable();
                }

                this.loading = false;
            });
        }
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudImportacion.Id) || this.navMenuService.currentSolicitudImportacion.Id !== id) {
            this.solicitudService.getSolicitud(id).subscribe(result => {
                this.navMenuService.currentSolicitudImportacion = result;
            });
        }
    }

    createForm() {
        this.form = this.fb.group({
            //IdSolicitud: this.navMenuService.currentSolicitudImportacion.Id,
            IdInspector: '',
            Aceptada: [{ value: 'S', disabled: true }, Validators.required],
            Fecha: [{ value: '', disabled: true }, Validators.required],
            Observaciones: [{ value: '', disabled: true }],
        });
    }

    updateForm() {
        this.form.setValue({
            //IdSolicitud: this.previa.IdSolicitud,
            IdInspector: this.solicitudPreviaInspector.TPreviaInspector.IdInspector,
            Aceptada: this.solicitudPreviaInspector.TPreviaInspector.Aceptada ? 'S' : 'N',
            Fecha: new Date(this.solicitudPreviaInspector.TPreviaInspector.Fecha),
            Observaciones: this.solicitudPreviaInspector.TPreviaInspector.Observaciones,
        });
    }

    onBack() {
        this.router.navigate(['/importacion/solicitud/datosbasicos', this.navMenuService.currentSolicitudImportacion.Id]);
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            this.addErrorMessage('Revise los datos');
            return;
        }

        this.visibilitySpinner = true;

        let previa = new TPreviaInspectorSolicitudViewModel();

        previa.IdSolicitud = this.idSolicitud;
        previa.IdInspector = this.form.value.IdInspector;
        previa.Aceptada = this.form.value.Aceptada == 'S' ? true : false;
        previa.Fecha = this.form.value.Fecha;
        previa.Observaciones = this.form.value.Observaciones;
        previa.IgnorarMirala = false; //this.form.value.IgnorarMirala;

        if (this.esNuevaPrevia) {
            this.previaInspectorService.createPrevia(previa).subscribe({
                next: res => {
                    this.addSuccessMessage('Solicitud previa creada correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        } else {
            this.previaInspectorService.editPrevia(previa).subscribe({
                next: res => {
                    this.addSuccessMessage('Solicitud previa modificada correctamente');
                    this.onBack();
                    this.visibilitySpinner = false;
                },
                error: error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                },
            });
        }
    }
}
